import { PopoverContent as ChakraPopoverContent, Text } from "@chakra-ui/react";
import type { PopoverContentProps } from "./PopoverContent.d";

const PopoverContent = ({ content }: PopoverContentProps) => (
  <ChakraPopoverContent
    p={{ base: 5 }}
    maxW={{ base: 64, md: "344px" }}
    color="primary.900"
    rounded="lg"
    zIndex="popover"
  >
    <Text dangerouslySetInnerHTML={{ __html: content }} fontSize="medium" />
  </ChakraPopoverContent>
);

export default PopoverContent;
